<template>
	<SupportEnquiryDialogModal :show="showModal" @close="handleModal(false)" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useIdle } from '@vueuse/core'
import SupportEnquiryDialogModal from '@/Components/SupportEnquiryDialogModal.vue'
import { useGetInTouch } from '@/Stores/getintouch'

const showModal = ref(false)

const getInTouchStore = useGetInTouch()

const handleModal = (status: boolean) => {
	showModal.value = status

	if (status === true) {
		getInTouchStore.resetStates()
	}
}

// Check idle time and show modal
const { idle, reset } = useIdle(5 * 60 * 1000) // 5 min

watch(idle, (idleValue) => {
	if (idleValue) {
		showModal.value = true
		reset()

		getInTouchStore.resetModal()
		getInTouchStore.resetStates()
	}
})
</script>
